// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"0dd5d645","475":"79f72a58"}[chunkId] + ".chunk.js";
};